import { AccountId, ContractId, TokenId } from '@hiero-ledger/sdk'
import { mirrorNodeFetch } from '@/services/mirrorNodeCache'

export const convertAccountIdToEVMAddress = (accountId: string) => {
  const normalized = AccountId.fromString(accountId)
  const evmAddress = normalized.evmAddress

  return evmAddress
}

export const convertEvmAddressToAccountId = (evmAddress: string) => {
  const shard = 0
  const realm = 0
  const accountId = AccountId.fromEvmAddress(shard, realm, evmAddress)
  return accountId.toString()
}

export const convertEvmAddressToContractId = (evmAddress: string) => {
  const shard = 0
  const realm = 0
  const accountId = ContractId.fromEvmAddress(shard, realm, evmAddress)
  return accountId.toString()
}

export const convertEvmAddressToTokenId = (evmAddress: string) => {
  try {
    const shard = 0
    const realm = 0
    const accountId = TokenId.fromEvmAddress(shard, realm, evmAddress)
    return accountId.toString()
  } catch (error) {
    return undefined
  }
}

export const checkIsPureERC20Token = async (tokenAddress: string, chainId: string): Promise<boolean> => {
  const tokenId = convertEvmAddressToTokenId(tokenAddress)
  if (!tokenId) return true

  const result = await mirrorNodeFetch(`/api/v1/tokens/${tokenId}`, chainId)
  return result === null
}

export const convertTokenIdToEVMAddress = (tokenId: string) => {
  const tokenIdObject = TokenId.fromString(tokenId)
  const evmAddress = tokenIdObject.toEvmAddress()
  return `0x${evmAddress}`
}
